"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StabilityDeposit = void 0;
const Decimal_1 = require("./Decimal");
/**
 * A Stability Deposit and its accrued gains.
 *
 * @public
 */
class StabilityDeposit {
    /**
     * Address of frontend through which this Stability Deposit was made.
     *
     * @remarks
     * If the Stability Deposit was made through a frontend that doesn't tag deposits, this will be
     * the zero-address.
     */
    /** @internal */
    constructor(initialYUSD, currentYUSD, collateralGain, yetiReward) {
        this.initialYUSD = initialYUSD;
        this.currentYUSD = currentYUSD;
        this.collateralGain = collateralGain;
        this.yetiReward = yetiReward;
        if (this.currentYUSD.gt(this.initialYUSD)) {
            throw new Error("currentYUSD can't be greater than initialYUSD");
        }
    }
    get isEmpty() {
        return (this.initialYUSD.isZero &&
            this.currentYUSD.isZero &&
            this.collateralGain.isZero &&
            this.yetiReward.isZero);
    }
    /** @internal */
    toString() {
        return (`{ initialYUSD: ${this.initialYUSD}` +
            `, currentYUSD: ${this.currentYUSD}` +
            `, collateralGain: ${this.collateralGain}` +
            `, yetiReward: ${this.yetiReward}`);
    }
    /**
     * Compare to another instance of `StabilityDeposit`.
     */
    equals(that) {
        return (this.initialYUSD.eq(that.initialYUSD) &&
            this.currentYUSD.eq(that.currentYUSD) &&
            JSON.stringify(this.collateralGain) == JSON.stringify(that.collateralGain) &&
            this.yetiReward.eq(that.yetiReward));
    }
    /**
     * Calculate the difference between the `currentYUSD` in this Stability Deposit and `thatYUSD`.
     *
     * @returns An object representing the change, or `undefined` if the deposited amounts are equal.
     */
    whatChanged(thatYUSD) {
        thatYUSD = Decimal_1.Decimal.from(thatYUSD);
        if (thatYUSD.lt(this.currentYUSD)) {
            return { withdrawYUSD: this.currentYUSD.sub(thatYUSD), withdrawAllYUSD: thatYUSD.isZero };
        }
        if (thatYUSD.gt(this.currentYUSD)) {
            return { depositYUSD: thatYUSD.sub(this.currentYUSD) };
        }
    }
    /**
     * Apply a {@link StabilityDepositChange} to this Stability Deposit.
     *
     * @returns The new deposited YUSD amount.
     */
    apply(change) {
        if (!change) {
            return this.currentYUSD;
        }
        if (change.withdrawYUSD !== undefined) {
            return change.withdrawAllYUSD || this.currentYUSD.lte(change.withdrawYUSD)
                ? Decimal_1.Decimal.ZERO
                : this.currentYUSD.sub(change.withdrawYUSD);
        }
        else {
            return this.currentYUSD.add(change.depositYUSD);
        }
    }
}
exports.StabilityDeposit = StabilityDeposit;
//# sourceMappingURL=StabilityDeposit.js.map